import React, { useEffect, useRef, useState } from "react";
import Snackbar from "../../../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import { studentPropCreate } from "../../../user.api";
import { builtup } from "./components/areadata";
import BasicDetails from "./components/basicDetails";
import View from "./components/viewDetails";
import "./style.css";
import Loader from "../../../../../components/loader/loader";
export default function NewCompanyRequest(props) {
  // let userData = jwtDecode(props.state.payload);
  const [activeStep, setActiveStep] = useState(0);
  const [defaultkey, setdefaultkey] = useState("");
  const [basicData, setBasicData] = useState({
    phone_number: props.phone,
    institution_id: props.institutions?.id,
    institution_name: props.institutions?.institution_name,
  });
  const [areaData, setAreaData] = useState({});
  const myRef = useRef(null);
  const [addCount, setCount] = useState(1);
  const [data, setData] = useState({});
  const [openView, setOpenView] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [areamange, setareaManage] = useState(builtup);
  const action = (id, data, key) => {
    myRef.current.scrollIntoView();
    if (id === 0) {
      setActiveStep(1);
      setBasicData({ ...basicData, ...data });
    } else if (id === 1) {
      setActiveStep(0);
      setdefaultkey(key);
    } else if (id === 2) {
      handleSubmit();
    }
  };
  const handleSubmit = () => {
    const form = new FormData();
    form.append("institution_id", basicData.institution_id ?? null);
    form.append("leader_phone_number", basicData.phone_number ?? null);
    form.append("project_title", basicData.project_title ?? null);
    form.append("project_title", basicData.project_title ?? null);
    form.append("project_guide1", basicData.project_guide1 ?? null);
    form.append("project_guide1_phone", basicData.project_guide1_phone ?? null);
    form.append("project_guide2_phone", basicData.project_guide2_phone ?? null);
    form.append("project_guide1_email", basicData.project_guide1_email ?? null);
    form.append("project_guide2_email", basicData.project_guide2_email ?? null);
    form.append("project_guide2", basicData.project_guide2 ?? null);
    form.append("group", basicData.group === "yes" ? 1 : 0);
    form.append("leader_student_name", basicData.leader_student_name ?? null);
    form.append("leader_semester", basicData.leader_semester ?? null);
    form.append("leader_branch", basicData.leader_branch ?? null);
    form.append("leader_email", basicData.leader_email ?? null);
    form.append("leader_photo", basicData.leader_photo ?? null);
    // form.append("leader_mark", basicData.leader_mark ?? null);
    form.append("leader_marklist", basicData.leader_marklist ?? null);
    form.append("leader_resume", basicData.leader_resume ?? null);
    form.append("file_upload_proposal", basicData.file_upload_proposal ?? null);
    form.append("letter", basicData.letter ?? null);

    form.append(
      "short_proposal_details",
      basicData.short_proposal_details ?? null
    );

    basicData.students.forEach((item, index) => {
      const hasData = item.student_name && item.student_name.trim() !== "";
      if (!hasData) return; 

      if (item.student_name)
        form.append(`students[${index}][student_name]`, item.student_name);
      if (item.semester)
        form.append(`students[${index}][semester]`, item.semester);
      if (item.branch) form.append(`students[${index}][branch]`, item.branch);
      if (item.photo) form.append(`students[${index}][photo]`, item.photo);
      if (item.marklist)
        form.append(`students[${index}][marklist]`, item.marklist);
      // if (item.mark) form.append(`students[${index}][mark]`, item.mark);
      if (item.duration)
        form.append(`students[${index}][duration]`, item.duration);
      if (item.resume) form.append(`students[${index}][resume]`, item.resume);
    });

    setIsActive(true);
    studentPropCreate(form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.response.data.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.logout();
    }
  };

  return (
    <div className="page-bg" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">Project Proposal</div>
        </div>
      </div>
      <div className="formbg form-bg">
        <div className="container form-section">
          <div className="items-cont2 container">
            <div className="form-inner-section">
              {activeStep === 0 && (
                <BasicDetails
                  {...props}
                  data={basicData}
                  action={action}
                  formData={basicData}
                />
              )}

              {activeStep === 1 && (
                <View {...props} basicData={basicData} action={action} />
              )}
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
